// extracted by mini-css-extract-plugin
export default {"link":"LinkBack_link__keLvV","icon":"LinkBack_icon__rLqfw","text":"LinkBack_text__lySAx"};